import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api/api';
import './ForgotPassword.css';

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    if (!email) {
      setError('Please enter your email address');
      setLoading(false);
      return;
    }

    try {
      const response = await authAPI.forgotPassword(email);
      if (response.data.success) {
        setMessage(response.data.message);
        setSubmitted(true);
        setEmail('');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to process request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card className="forgot-password-card shadow-lg">
          <Card.Header className="bg-primary text-white text-center py-4">
            <h2>Reset Your Password</h2>
          </Card.Header>
          <Card.Body className="p-5">
            {submitted ? (
              <>
                <Alert variant="success" className="mb-4">
                  <h4>Check Your Email</h4>
                  <p>
                    If an account exists with the email address you provided, 
                    you will receive an email with instructions to reset your password.
                  </p>
                  <p className="mb-0 text-muted small">
                    The reset link will expire in 1 hour.
                  </p>
                </Alert>
                <div className="text-center">
                  <p className="text-muted">
                    Remember your password? <a onClick={() => navigate('/login')} style={{ cursor: 'pointer' }}>Back to login</a>
                  </p>
                </div>
              </>
            ) : (
              <>
                <p className="text-muted mb-4">
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                {error && <Alert variant="danger" className="mb-4">{error}</Alert>}
                {message && <Alert variant="info" className="mb-4">{message}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      We'll send you a password reset link.
                    </Form.Text>
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </Button>
                </Form>

                <hr className="my-4" />

                <div className="text-center">
                  <p className="text-muted">
                    Remember your password? <a onClick={() => navigate('/login')} style={{ cursor: 'pointer' }}>Back to login</a>
                  </p>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default ForgotPassword;
